import { standardRequestWithErrorFlash } from 'shared/utils/request';
import { SecurityScreening } from '../types';

export const fetchSecurityScreening = async (path: string) => {
  const result = await standardRequestWithErrorFlash.get<SecurityScreening>(
    path
  );

  return result.data;
};

export const updateLastSeenIdentityVerification = async (path: string) => {
  const result = await standardRequestWithErrorFlash.post(path);

  return result.data.last_seen_identity_verification;
};

export const updateLastSeenFraudReport = async (path: string) => {
  const result = await standardRequestWithErrorFlash.post(path);

  return result.data.last_seen_fraud_report;
};
